import React, { useEffect } from "react";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { useSaveLeaveTypesMutation } from "../../services/settings.service";
import {ClipLoader} from "react-spinners";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import alertify from "alertifyjs";


const FormSchema = Yup.object().shape({
  name: Yup.string()
      .min(2, "Minimum 3 letters")
      .required("Please enter a name"),
  code: Yup.string().required()
});

const LeaveTypeModal = ({leaveType}) => {

  const [saveLeaveType, {isLoading, data, error}] = useSaveLeaveTypesMutation();

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  useEffect(() => {
    if (data && data.success) {
      alertify.success(data?.message);
      document.getElementById('close-modal').click()
    }

    if (error) {
      alertify.error(error?.message);
    }
  }, [data, error]);

  useEffect(() => {
    if (leaveType) {
      setValue('name', leaveType.name);
      setValue('code', leaveType.code);
      setValue('id', leaveType.id);
    }
  }, [leaveType]);

  const save = payload => {
    saveLeaveType(payload);
  }

  return (
    <>
      {/* Add/Edit Leavetype Modal */}
      <div id="add_leavetype" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{leaveType ? 'Edit' : 'Add New'} Leave Type</h5>
              <button
                type="button"
                id="close-modal"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(save)}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Leave Type <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <input
                        className={`form-control ${
                          errors?.name ? "is-invalid" : ""
                        }`}
                        type="text"
                        value={value}
                        onChange={onChange}
                        autoComplete="false"
                      />
                    )}
                  />
                  <span className="text-danger">
                    {errors?.name?.message}
                  </span>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Leave Code <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="code"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <input
                        className={`form-control ${
                          errors?.code ? "is-invalid" : ""
                        }`}
                        type="text"
                        value={value}
                        onChange={onChange}
                        autoComplete="false"
                      />
                    )}
                  />
                  <span className="text-danger">
                    {errors?.code?.message}
                  </span>
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                  >
                    {!isLoading ? 'Save' : <ClipLoader color="#ffffff" />}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Add/Edit Leavetype Modal */}
    </>
  );
};

export default LeaveTypeModal;
